export default __webpack_public_path__ + "static/media/App-penjualan.cda6c638.png";